export default __webpack_public_path__ + "static/media/gallery-wip-pommel_03.a5418509.jpg";